import { createSelector } from 'reselect';

const selectDomain = () => (state) => state.get('fileUploadOverlay');

const makeSelectUploading = () =>
  createSelector(selectDomain(), (state) => state.get('uploading'));

export { makeSelectUploading };
